module.exports = __webpack_public_path__ + "img/upload-file-accent-green-icon.eea33dd3.svg";